/** @namespace ShopifyShop/Api/Shop/Processor/processShop */
export const processShop = () => {};
